// Color links still navigate to the exact variant; hover and keyboard focus
// preview its real garment photo without entering a quick-buy flow.
class EveryteeCard extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const photo = this.querySelector('.et-card-photo img');
    if (!photo) return;
    const original = {src:photo.getAttribute('src'),srcset:photo.getAttribute('srcset'),alt:photo.alt};
    const restore = () => {
      photo.src = original.src;
      if (original.srcset) photo.setAttribute('srcset',original.srcset);
      photo.alt = original.alt;
    };
    for (const link of this.querySelectorAll('[data-color-photo]')) {
      const preview = () => {
        if (!link.dataset.colorPhoto) return;
        photo.removeAttribute('srcset');
        photo.src = link.dataset.colorPhoto;
        photo.alt = link.getAttribute('aria-label');
      };
      link.addEventListener('mouseenter',preview);
      link.addEventListener('focus',preview);
    }
    this.addEventListener('mouseleave',restore);
    this.addEventListener('focusout',event => {if (!this.contains(event.relatedTarget)) restore();});
  }
}
if (!customElements.get('everytee-card')) customElements.define('everytee-card',EveryteeCard);
